const foundPetOutcomes = [
  {
    value: 'left_on_place',
    label: {
      en: 'Left on the place',
      es: 'Dejado en el lugar',
    },
  },
  {
    value: 'found_and_left_elsewhere',
    label: {
      en: 'Found and left elsewhere',
      es: 'Encontrado y dejado en otro lugar',
    },
  },
  {
    value: 'found_and_with_user',
    label: {
      en: 'Found and picked up',
      es: 'Encontrado y recogido',
    },
  },
  {
    value: 'found_and_passed_away',
    label: {
      en: 'Found passed away',
      es: 'Encontrado fallecido',
    },
  },
];

export default foundPetOutcomes;
